import { combineReducers } from 'redux';
import ajaxStatus from '../../__core/Providers/AjaxStatus/AjaxStatusReducer';
import { appReducer } from '../../Modules/App/Reducers/AppReducer';
import { courseInstanceReducer } from '../../Modules/CourseInstance/Reducers/CourseInstanceReducer';
import { directAccessReducer } from '../../Modules/DirectAccess/Reducers/DirectAccessReducer';
import { coursesReducer } from '../../Modules/Courses/Reducers/Courses';
import { courseReducer } from '../../Modules/Course/Reducers/Course';
import { materialReducer } from '../../Modules/Material/Reducers/Material';
import { registerInfoReducer } from '../../Modules/App/Reducers/RegisterInfoReducer';
import { learningProgressReducer } from '../../Modules/CourseInstance/Components/LearningProgress/Reducers/LearningProgressReducer';

export default combineReducers({
  App: appReducer,
  ajaxCallInProgressCount: ajaxStatus,
  CourseInstance: courseInstanceReducer,
  DirectAccess: directAccessReducer,
  Courses: coursesReducer,
  Course: courseReducer,
  Material: materialReducer,
  RegisterInfo: registerInfoReducer,
  LearningProgress: learningProgressReducer,
});
